export default __webpack_public_path__ + "static/epk-cf2e7b3e370522d78515ee0abe9c3e42.jpg";